module.exports = require("./dist/is-android");